import {arrayMove} from '@dnd-kit/sortable';
import {DragEndEvent} from '@dnd-kit/core';
import {
  ArrayItemType,
  MockDrageEndEvent,
  SortItemType,
} from '../eca-doc-list.util';

type DragItemType = SortItemType | ArrayItemType;

interface HandleDragOptions {
  preventMoveAboveFieldName?: string; // e.g., 'documentid' or 'confidence_score' or any column
}

export function HandleDrag<T extends DragItemType>(
  event: DragEndEvent | MockDrageEndEvent,
  setItems: React.Dispatch<React.SetStateAction<T[]>>,
  options?: HandleDragOptions
) {
  const {active, over} = event;
  if (!over || active.id === over.id) return;

  setItems((items) => {
    const oldIndex = items?.findIndex((item) => item?.id === active?.id);
    const newIndex = items?.findIndex((item) => item?.id === over?.id);

    // Optional constraint: prevent moving above specific field name
    if (options?.preventMoveAboveFieldName) {
      const restrictedIndex = items.findIndex(
        (item) =>
          'fieldValue' in item &&
          item.fieldValue?.name === options.preventMoveAboveFieldName
      );
      if (restrictedIndex !== -1 && newIndex <= restrictedIndex) {
        return items; // Disallow movement above the restricted item
      }
    }

    // Default reordering using arrayMove
    return arrayMove(items, oldIndex, newIndex);
  });
}
